/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { IconButton } from '@mui/material';
import { useGridApiRef, GridActionsCellItem } from '@mui/x-data-grid-pro';

import DeleteIcon from '@mui/icons-material/DeleteOutlined';

import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import AskDialog from '../../../components/common/dialog/AskDialog';
import * as fileApi from '../../../lib/api/file';
import ProjectFileList from '../../../components/projectmng/files/ProjectFileList';
import {
  listProjectFiles,
  unloadFiles,
} from '../../../modules/projectModule/projectFiles';

const ProjectFileListContainer = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { project, files, error, loading } = useSelector(
    ({ projectModule, loading }) => ({
      project: projectModule.project.project,
      files: projectModule.projectFiles.files,
      error: projectModule.projectFiles.error,
      loading: loading['project/LIST_PROJECT_FILES'],
    }),
  );

  useEffect(() => {
    if (project) {
      dispatch(listProjectFiles({ prjUuid: project?.prjUuid }));
    }

    //언마운트될때 리덕스에서 파트너 데이터 초기화
    return () => {
      dispatch(unloadFiles());
    };
  }, [project]);

  const apiRef = useGridApiRef();

  const handleClick = (id) => (event) => {
      event.stopPropagation();
      onDownLoad(id);
  };

    const onDownLoad = async (param) => {
      fileApi.downloadNew(param);
  };
  
  const downloadFile = (file) => {
    const url = file.fileUrl;

    fetch(url, { method: 'GET' })
      .then((res) => {
        return res.blob();
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = file.fileNm;
        document.body.appendChild(a);
        a.click();
        setTimeout((_) => {
          window.URL.revokeObjectURL(url);
        }, 60000);
        a.remove();
      })
      .catch((err) => {
        console.error('err: ', err);
      });
  };

  const [removeId, setRemoveId] = useState(null);
  const handleDeleteClick = (id) => (event) => {
    event.stopPropagation();

    //remove 작업
    setVisible(true);
    setRemoveId(id);
  };

  const onRemove = async () => {
    try {
      const res = await fileApi.removeFile(removeId);
      if (res) {
        apiRef.current.updateRows([{ id: removeId, _action: 'delete' }]);
        enqueueSnackbar('삭제 성공', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
    setRemoveId(null);
  };

  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        type: 'string',
        editable: false,
        disableExport: true,
      },
      {
        field: 'prjUuid',
        headerName: '프로젝트ID',
        hide: true,
        type: 'string',
        editable: false,
        disableExport: true,
      },
      {
        field: 'filePartnerUuid',
        headerName: '견적서회사ID',
        hide: true,
        type: 'string',
        editable: false,
        disableExport: true,
      },
      {
        field: 'filePartnerNm',
        headerName: '매입처명',
        minWidth: 300,
        flex: 1,
        type: 'string',
        align: 'left',
        headerAlign: 'left',
        editable: false,
      },
      {
        field: 'fileRegDt',
        headerName: '받은(수신)일자',
        minWidth: 200,
        flex: 1,
        type: 'string',
        align: 'left',
        headerAlign: 'left',
        editable: false,
      },
      {
        field: 'fileCrtDt',
        headerName: '파일등록일',
        minWidth: 200,
        flex: 1,
        type: 'string',
        align: 'left',
        headerAlign: 'left',
        editable: false,
      },
      {
        field: 'cstNm',
        headerName: '사업명',
        minWidth: 400,
        flex: 1,
        description: '',
        align: 'left',
        headerAlign: 'left',
        editable: false,
      },
      {
        field: 'fileNm',
        headerName: '파일명',
        minWidth: 600,
        flex: 1,
        type: 'string',
        editable: false,
        disableClickEventBubbling: true,
        renderCell: (params) => (
          <div>
            {params.row.fileNm}
            {params.row.fileUrl && (
              <IconButton
                color="primary"
                size="small"
                sx={{ mx: 2 }}
                //onClick={(e) => downloadFile(params.row)}
                onClick={handleClick(params)}
              >
                <CloudDownloadIcon />
              </IconButton>
            )}
          </div>
        ),
      },
      {
        field: 'fileCrtNm',
        headerName: '파일등록자',
        minWidth: 200,
        flex: 1,
        type: 'string',
        align: 'left',
        headerAlign: 'left',
        editable: false,
      },
      {
        field: 'actions',
        type: 'actions',
        headerName: 'Actions',
        width: 100,
        cellClassName: 'actions',
        getActions: ({ id }) => {
          return [
            <GridActionsCellItem
              icon={<DeleteIcon />}
              label="Delete"
              onClick={handleDeleteClick(id)}
              color="inherit"
            />,
          ];
        },
      },
    ],
    [apiRef, handleDeleteClick],
  );

  const [visible, setVisible] = useState(false);

  const onCancle = () => {
    setVisible(false);
    setRemoveId(null);
  };

  const onConfirm = () => {
    setVisible(false);
    onRemove();
  };

  return (
    <>
      <ProjectFileList
        apiRef={apiRef}
        columns={columns}
        files={files}
        error={error}
        loading={loading}
      />
      <AskDialog
        visible={visible}
        title="프로젝트 파일 삭제"
        description="선택한 프로젝트 파일을 삭제하시겠습니까?"
        confirmText="삭제"
        onConfirm={onConfirm}
        onCancle={onCancle}
      />
    </>
  );
};

export default ProjectFileListContainer;
